/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandsList } from '../models/BrandsList';
import type { BrowseCollectionsV2 } from '../models/BrowseCollectionsV2';
import type { CategoriesWithCollectionsV2 } from '../models/CategoriesWithCollectionsV2';
import type { CollectionsV2 } from '../models/CollectionsV2';
import type { ContextActionRequest } from '../models/ContextActionRequest';
import type { DisplatePdpGeneralV2 } from '../models/DisplatePdpGeneralV2';
import type { DisplatePdpGeneralV3 } from '../models/DisplatePdpGeneralV3';
import type { HomepageV2 } from '../models/HomepageV2';
import type { HomepageV3 } from '../models/HomepageV3';
import type { HomepageV4 } from '../models/HomepageV4';
import type { LuminoListingResponseV3 } from '../models/LuminoListingResponseV3';
import type { LuminoV4 } from '../models/LuminoV4';
import type { MonolithContextActionResponse } from '../models/MonolithContextActionResponse';
import type { PhraseAutocomplete } from '../models/PhraseAutocomplete';
import type { Recommended } from '../models/Recommended';
import type { SliderCategory } from '../models/SliderCategory';
import type { Sort } from '../models/Sort';
import type { TopBar } from '../models/TopBar';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BfwGeneralDataService {
  /**
   * createContextAction
   * Creates action context for unlogged user in order to execute his last action as guest after signing in/up
   *
   * @param requestBody Payload for action made by user before sign in/up
   * @returns MonolithContextActionResponse Create context action for guest before login
   * @throws ApiError
   */
  public static createContextAction(
    requestBody: ContextActionRequest,
  ): CancelablePromise<MonolithContextActionResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/elysium-api/context-action/v1',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * getBrands
   * Returns list of all brands
   *
   * @returns BrandsList Full list of brands
   * @throws ApiError
   */
  public static getBrands(): CancelablePromise<BrandsList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v1/brands',
    });
  }

  /**
   * Gets Categories
   * categories
   * @returns SliderCategory categories
   * @throws ApiError
   */
  public static getCategoriesSlider(): CancelablePromise<Array<SliderCategory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v1/categories/slider',
    });
  }

  /**
   * Gets phrases
   * phrases
   * @param phrase
   * @returns PhraseAutocomplete phrases
   * @throws ApiError
   */
  public static getSearchAutocomplete(phrase: string): CancelablePromise<PhraseAutocomplete> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v1/search/autocomplete',
      query: {
        phrase: phrase,
      },
    });
  }

  /**
   * Gets recommended
   * recommended for search
   * @returns Recommended recommended for search
   * @throws ApiError
   */
  public static getRecommended(): CancelablePromise<Recommended> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v1/search/recommended',
    });
  }

  /**
   * Gets top bar customisation
   * top bar customisation parameters and content
   * @returns TopBar top bar customisation parameters and content for desktop and mobile
   * @throws ApiError
   */
  public static getTopBarContent(): CancelablePromise<TopBar> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v1/topbar-content',
    });
  }

  /**
   * getBrandsFilteredForCountry
   * Returns list of brands available for specific country
   *
   * @returns BrandsList List of brands available for specific country
   * @throws ApiError
   */
  public static getBrandsFilteredForCountry(): CancelablePromise<BrandsList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v2/brands',
    });
  }

  /**
   * Gets collections and categories
   * collections and categories
   * @returns BrowseCollectionsV2 collections and categories
   * @throws ApiError
   */
  public static getCollectionsBrowseV2(): CancelablePromise<BrowseCollectionsV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v2/collections/browse/',
    });
  }

  /**
   * Gets categories with collections from user keywords
   * Allows to get user categories from keywords by cookie.
   * If cookie is present then gets keywords from sapi based on user cookie else use given list of categories.
   * In addition, the list from "pe" is always used.
   * Output is always filtered only to existing categories.
   * Then returns categories with collections.
   *
   * @param page
   * @param limit
   * @param categories
   * @param pe
   * @param sort sort by: trending or new or bestselling
   * @returns CategoriesWithCollectionsV2 Categories with collections from keywords
   * @throws ApiError
   */
  public static getCategoriesWithCollectionsV2(
    page: number,
    limit: number,
    categories?: Array<string> | null,
    pe?: Array<string> | null,
    sort?: Sort | null,
  ): CancelablePromise<CategoriesWithCollectionsV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v2/collections/browse/categories/all',
      query: {
        categories: categories,
        pe: pe,
        sort: sort,
        page: page,
        limit: limit,
      },
      errors: {
        401: `No elysium cookie in request`,
      },
    });
  }

  /**
   * collections and categories
   * Gets collections for given categorySlug and categories
   * @param categorySlug
   * @param page
   * @param limit
   * @param sort sort by: trending or new or bestselling
   * @returns CollectionsV2 Gets collections for given categorySlug and categories
   * @throws ApiError
   */
  public static getCollectionsByCategoryV2(
    categorySlug: string,
    page: number,
    limit: number,
    sort?: Sort | null,
  ): CancelablePromise<CollectionsV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v2/collections/browse/category/{categorySlug}',
      path: {
        categorySlug: categorySlug,
      },
      query: {
        sort: sort,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * @deprecated
   * Gets displate pdp page data
   * Endpoint for regular displate product PDP page.
   * Gets detailed artwork, delivery information, seo for pdp, pricing, etc
   *
   * @param externalId External Id (or ItemCollectionId) of the product
   * @param countryCode Country code to be used for shopping context
   * @returns DisplatePdpGeneralV2 Full general displate PDP data
   * @throws ApiError
   */
  public static getDisplatePdpV2(
    externalId: number,
    countryCode: string,
  ): CancelablePromise<DisplatePdpGeneralV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v2/displate-pdp/{externalId}',
      path: {
        externalId: externalId,
      },
      query: {
        countryCode: countryCode,
      },
    });
  }

  /**
   * @deprecated
   * getHomepage
   * Returns all general data needed for homepage
   *
   * @returns HomepageV2 Full general displate homepage data
   * @throws ApiError
   */
  public static getHomepageV2(): CancelablePromise<HomepageV2> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v2/homepage',
    });
  }

  /**
   * Gets displate pdp page data
   * Endpoint for regular displate product PDP page.
   * Gets detailed artwork, delivery information, seo for pdp, pricing, etc
   *
   * @param externalId External Id (or ItemCollectionId) of the product
   * @param countryCode Country code to be used for shopping context
   * @returns DisplatePdpGeneralV3 Full general displate PDP data
   * @throws ApiError
   */
  public static getDisplatePdpV3(
    externalId: number,
    countryCode: string,
  ): CancelablePromise<DisplatePdpGeneralV3> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v3/displate-pdp/{externalId}',
      path: {
        externalId: externalId,
      },
      query: {
        countryCode: countryCode,
      },
    });
  }

  /**
   * getHomepage
   * Returns all general data needed for homepage
   *
   * @returns HomepageV3 Full general displate homepage data
   * @throws ApiError
   */
  public static getHomepageV3(): CancelablePromise<HomepageV3> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v3/homepage',
    });
  }

  /**
   * Gets lumino listing data with TopBar data
   * Returns lumino listing data with newest lumino, and sets of 6(default) upcoming, active and sold-out luminos. + TopBar data
   *
   * @param limit
   * @returns LuminoListingResponseV3 Gets lumino listing data
   * @throws ApiError
   */
  public static getLuminoListingV3(
    limit?: number | null,
  ): CancelablePromise<LuminoListingResponseV3> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v3/lumino/listing',
      query: {
        limit: limit,
      },
    });
  }

  /**
   * getHomepage
   * Returns all general data needed for homepage
   *
   * @returns HomepageV4 Full general displate homepage data
   * @throws ApiError
   */
  public static getHomepageV4(): CancelablePromise<HomepageV4> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v4/homepage',
    });
  }

  /**
   * Gets lumino data
   * Gets
   * Detailed Lumino artwork data
   * Lists: Lumino, Bestselling, Trending, Brand
   *
   * @param externalId
   * @returns LuminoV4 Gets lumino data with TopBar data
   * @throws ApiError
   */
  public static getLuminoV4(externalId: number): CancelablePromise<LuminoV4> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/elysium-api/general/v4/lumino/{externalId}',
      path: {
        externalId: externalId,
      },
    });
  }
}
